<div class="toast-item {{type}}{{isClosing ? ' closing' : ''}}{{isDirect ? ' direct' : ''}}{{showIcon ? ' icon' : ''}}{{showCloseButton ? ' close-bt' : ''}}" (click)="onclick($event)">
    <span class="icon icon-type">
        <span><i class="{{iconClassList[type]}}" aria-hidden="true"></i></span>
    </span>
    <span class="text" [innerHTML]="message" [ngClass]="{'message': !!showCloseModalButton}"></span>
    <span class="btn-close">
        <button class="ok" (click)="onClose($event)">{{ textButton }}</button>
    </span>

    <span class="close-modal" (click)="closeModal($event)" *ngIf="!!showCloseModalButton">
        {{ textCloseModalButton }}
    </span>

</div>


